import React from 'react';
import styled from 'styled-components';
import { Link as RouterDomLink, LinkProps } from 'react-router-dom';

import { themeColor } from '~/common/utils/theme';

export const ContractFieldValue = styled.div`
  display: flex;
  color: ${({ theme }) => theme.colors.brand.primary};

  p {
    margin: 0;
  }

  svg {
    margin-top: 2px;
    margin-left: 8px;
    cursor: pointer;
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 320px;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const Link = styled((props: LinkProps) => <RouterDomLink {...props} />)`
  color: ${themeColor('brand.primary', { dark: 'brand.primaryAlt' })};
  flex-shrink: 0;
`;

export const ContractPopoverItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 4px 0;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.background.tertiary};
    padding-bottom: 8px;
    margin-bottom: 4px;
  }
`;

export const ContractPopoverRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 6px;
  min-width: 0;
`;

export const ContractPopoverDetail = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.element.secondary};
  min-width: 0;
  overflow-wrap: anywhere;
`;

export const ContractPopoverConsignee = styled.span`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.element.secondary};
  overflow-wrap: anywhere;
`;
